import React from 'react';
import {Route, Switch} from "react-router-dom";
import {Home} from "./Home/Home";
import {AboutUs} from "./AboutUs/AboutUs";
import {Services} from "./Services/Services";
import ContactUs from './ContactUs/ContactUs';

const MainLayout = () => {
    return (
       <div className="main-container-original">
           <Switch >
               <Route path={'/'} exact component={Home} />
               {/*<Route path={'/*path'} exact component={Home} />*/}
               <Route path={'/about-us'} exact component={AboutUs} />
               <Route path={'/services'} exact component={Services}/>
               <Route path={'/contact-us'} exact component={ContactUs}/>
           </Switch>
       </div>
    )
}
export default MainLayout;
